import { render, staticRenderFns } from "./RequestPriorityBadge.vue?vue&type=template&id=5ea2da84"
import script from "./RequestPriorityBadge.vue?vue&type=script&lang=js"
export * from "./RequestPriorityBadge.vue?vue&type=script&lang=js"
import style0 from "./RequestPriorityBadge.vue?vue&type=style&index=0&id=5ea2da84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports